module.exports = __webpack_public_path__ + "images/menu_legal.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/menu_legal.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--2-0!/tool/node_modules/img-loader/index.js??ref--2-1!/tool/project/client/src/site__mhf/images/menu_legal.svg
// module chunks = site__mhf